import React, { useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { useAppSelector } from "./Hooks/Hooks";
import { selectActiveTheme } from "./Redux/ThemeSlice/ThemeSlice";
import { Home } from "./Pages/Home/Home";
import { useAppDispatch } from "./Hooks/Hooks";
import {
    setStaticData,
    setLoading,
    setLandingData,
} from "./Redux/DataSlice/DataSlice";
import { GetGeneralDataRequest } from "./BackednInteraciton/GetRequests/GetGeneralData";

const App = () => {
    const theme = useAppSelector(selectActiveTheme);
    const dispatch = useAppDispatch();
    useEffect(() => {
        GetGeneralDataRequest(
            (loadingState) => dispatch(setLoading(loadingState)),
            (json) => {
                dispatch(setStaticData(json));
                dispatch(setLandingData(json));
            },
            (error: Error) => console.log(error)
        );
    }, [dispatch]);
    return (
        <ThemeProvider theme={theme}>
            <Home />
        </ThemeProvider>
    );
};

export default App;
